<template>
  <c-transition>
    <c-tooltip
      class="c-info-list-tooltip"
      v-bind="$attrs"
    >
      <div
        v-for="info in infoList"
        :key="info.value"
        :class="[ 'info', {
          '-center': textAlign === 'center',
          '-right': textAlign === 'right',
          '-left': textAlign === 'left',
        } ]"
      >
        <span
          v-if="info.title"
          :class="[ 'title', {
            '-has-value': info?.value
          } ]"
          v-html="info.title"
        />

        <span
          v-if="info.value"
          class="value"
          v-html="info.value"
        />

        <div
          v-if="info.employees"
          class="employee"
        >
          <c-employee-info
            v-for="employee in info.employees"
            class="employee-info"
            size="30"
            grey
            hide-tooltip
            hide-avatar-tooltip
            initials-size="14"
            :icon-size="20"
            :key="employee.id"
            :name="employee.name"
            :src="employee.photo"
            :name-suffix="employee.nameSuffix"
            :is-active-user="employee.isActiveUser"
            :icon="employee.icon"
          >
            <span
              v-if="employee.description"
              class="description"
              v-html="employee.description"
            />
          </c-employee-info>
        </div>

        <span
          v-if="info.concludingText"
          class="concludingText"
          v-html="info.concludingText"
        />
      </div>
    </c-tooltip>
  </c-transition>
</template>

<script>
import CTransition from '@convenia/components/CTransition'
import CTooltip from '@convenia/components/CTooltip'
import CEmployeeInfo from '@convenia/components/CEmployeeInfo'

const checkPlacement = (types, v) => typeof v === 'string' && types.indexOf(v) > -1

export default {
  name: 'CInfoListTooltip',

  components: {
    CTransition,
    CTooltip,
    CEmployeeInfo
  },

  props: {
    /**
     * Information to be displayed.
     * @type {Item[]}
     */
    infoList: {
      type: Array,
      default: () => [],
    },

    /**
     * Content alignment, which can be center, right, or left.
     * @type {String}
     */
    textAlign: {
      type: String,
      default: 'center',
      validator: v => checkPlacement([ 'right', 'center', 'left' ], v)
    },
  },
}
</script>

<style lang="scss">
.c-info-list-tooltip > .popover > .card > .info {
  margin-bottom: 5px;

  &.-center {
    text-align: center;
  }

  &.-right {
    text-align: right;
  }

  &.-left {
    text-align: left;
  }

  &:last-child {
    margin-bottom: 0;
  }

  & > .title {
    display: block;
    font-family: var(--title-font-family);
    font-size: 11px;
    font-weight: var(--title-font-weight);
    line-height: 14px;
    text-transform: uppercase;
    color: rgba(color-var(white, base-rgb), 0.8);

    &.-has-value {
      margin-bottom: 5px;
    }
  }

  & > .value {
    display: block;
    font-family: var(--base-font-family);
    font-size: 14px;
    font-weight: var(--base-font-weight);
    line-height: 19px;
    color: rgba(color-var(white, base-rgb), 0.8);
  }

  & > .employee {
    margin: 10px 0;

    & > .employee-info {
      margin-top: 10px;
      display: flex;
      align-items: center;

      & > .icon {
        background-color: rgba-to-rgb(map-get($text-color, base-20));
      }

      & > .info {
        & > .name {
          font-family: var(--title-font-family);
          font-size: 12px;
          font-weight: var(--font-weight-medium);
          line-height: 16px;
          color: rgba(color-var(white, base-rgb), 0.5);
          padding-bottom: 0;
        }

        & > .description {
          font-family: var(--base-font-family);
          font-size: 14px;
          font-weight: var(--base-font-weight);
          line-height: 19px;
          color: rgba(color-var(white, base-rgb), 0.3);
        }
      }
    }
  }

  & > .concludingText {
    display: block;
    font-family: var(--base-font-family);
    font-size: 14px;
    font-weight: var(--base-font-weight);
    line-height: 19px;
    color: rgba(color-var(white, base-rgb), 0.5);
    margin-bottom: 10px;
  }
}
</style>
